export default "__VITE_ASSET__c3f8b384__"